import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-puntosdeventa',
  templateUrl: './puntosdeventa.component.html',
  styleUrls: ['./puntosdeventa.component.scss']
})
export class PuntosdeventaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
